/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { OasLicense } from '../../models/OasLicense';

/**
 * Constructor.
 * @class
 * @extends OasLicense
 * @author eric.wittmann@gmail.com
 */
export class Oas30License extends OasLicense {
    public constructor() {
        super();
    }
}
Oas30License["__class"] = "io.apicurio.datamodels.openapi.v3.models.Oas30License";
Oas30License["__interfaces"] = ["io.apicurio.datamodels.core.models.IVisitable"];




